import PropTypes from "prop-types";

import { useGivenOrGeneratedId } from "../../hookHelpers";

import { variantDictionary, sizeDictionary } from "./FilterPill.styles";

const FilterPill = ({
  children,
  disabled = false,
  id: idFromProps = null,
  onClick = null,
  selected = false,
  variant = "gray",
  size = "small",
  className = "",
  containerClassName = "",
  labelClassName = "",
}) => {
  const sizeClasses = sizeDictionary[size];
  const variantClasses = variantDictionary[variant];
  const id = useGivenOrGeneratedId("filter-pill", idFromProps);

  return (
    <span className={containerClassName}>
      <input
        id={id}
        type="checkbox"
        disabled={disabled}
        checked={selected}
        onChange={onClick}
        className={`${className} tw-peer tw-sr-only`}
      />

      <label htmlFor={id} className={`${sizeClasses} ${variantClasses} ${labelClassName}`}>
        {children}
      </label>
    </span>
  );
};

FilterPill.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  variant: PropTypes.oneOf(["gray", "primary"]),
  size: PropTypes.oneOf(["small", "medium"]),
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
};

export default FilterPill;
